export default __webpack_public_path__ + "static/media/download.02a3ff25.svg";